import { Component, OnInit, OnDestroy } from "@angular/core";
import {InteractivesService, PreFilterInteractivesService, SubscriptionService} from "../../api/services";
import {
  DropDownItem,
  UserState,
  US_Interactive,
  US_ModifiedInteractive, US_PreFilterInteractives,
} from "../../api/models";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import {
  CopyInteractiveDialogComponent,
  CopyInteractiveDialogData,
} from "../../dialogs/copy-interactive-dialog/copy-interactive-dialog.component";
import { DialogResultType } from "../../dialogs/DialogResult";
import {
  ConfirmDialogData,
  ConfirmDialogComponent,
} from "../../dialogs/confirm-dialog/confirm-dialog.component";
import { GlobalApp } from "../../tools/global";
import { Subscription } from "rxjs";
import { UserTypeValue } from "../../api/models-ex/user-type-values";
import {UserStateEx} from "../../api/models-ex/user-state-ex";
import { DropDownSelectDialogComponent } from "../../dialogs/dropdown-select-dialog/dropdown-select-dialog.component";

@Component({
  selector: "app-interactive",
  templateUrl: "./interactive.component.html",
})
export class InteractiveComponent implements OnInit, OnDestroy {
  userState: UserState = {
    reportOnly: false,
    userManagerOnly: false,
    invoiceManagerOnly: false,
    interactives: [],
    modifiedInteractives: [],
    preFilteredInteractives: [],
    xmlas: [],
  };
  userStateSubscription: Subscription = null;

  public myInteractives: DropDownItem[] = [];
  public modInteractives: DropDownItem[] = [];
  public freeInteractives: DropDownItem[] = [];
  public loadingData = false;

  public availableInteractives: US_Interactive[] = [];
  public availableModifiedInteractives: US_ModifiedInteractive[] = [];
  //public availablePreFilteredInteractives: US_PreFilterInteractives[] = [];

  constructor(
    private interactiveService: InteractivesService,
    private subscriptionService: SubscriptionService,
    private preFilterInteractiveService: PreFilterInteractivesService,
    private app: GlobalApp,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.app.getAuthorizationStatus().subscribe((result) => {
      if (!result.isValid) {
        this.app.logOut();
        this.router.navigate(["login"]);
      } else {
        this.loadUserState();
        //this.loadInteractives();
      }
    });
  }

  ngOnInit() {
    this.userStateSubscription = this.app.userState.subscribe((userState) => {
      this.userState = userState;

      this.availableInteractives = [];
      for (let i = 0; i < this.userState.interactives.length; i++) {
        let isAvailable = false;
        for (
          let e = 0;
          e < this.userState.interactives[i].subscriptionHeaders.length;
          e++
        ) {
          if (
            this.userState.interactives[i].subscriptionHeaders[e].userType !==
            UserTypeValue.NoRole
          ) {
            isAvailable = true;
          }
        }

        if (!this.userState.interactives[i].isActive) {
          isAvailable = false;
        }

        if (isAvailable) {
          this.availableInteractives.push(this.userState.interactives[i]);
        }
      }

      this.availableModifiedInteractives = [];
      for (let i = 0; i < this.userState.modifiedInteractives.length; i++) {
        let isAvailable = false;
        for (
          let e = 0;
          e < this.userState.modifiedInteractives[i].subscriptionHeaders.length;
          e++
        ) {
          if (
            this.userState.modifiedInteractives[i].subscriptionHeaders[e]
              .userType !== UserTypeValue.NoRole
          ) {
            isAvailable = true;
          }
        }

        if (isAvailable) {
          this.availableModifiedInteractives.push(
            this.userState.modifiedInteractives[i]
          );
        }
      }

      /*this.availablePreFilteredInteractives = [];
      for (let i = 0; i < this.userState.preFilteredInteractives.length; i++) {
        let isAvailable = false;
        for (
          let e = 0;
          e < this.userState.preFilteredInteractives[i].subscriptionHeaders.length;
          e++
        ) {
          if (
            this.userState.preFilteredInteractives[i].subscriptionHeaders[e]
              .userType !== UserTypeValue.NoRole
          ) {
            isAvailable = true;
          }
        }

        if (isAvailable) {
          this.availablePreFilteredInteractives.push(
            this.userState.preFilteredInteractives[i]
          );
        }
      }*/

      this.loadingData = false;
    });
  }

  ngOnDestroy() {
    if (this.userStateSubscription) {
      this.userStateSubscription.unsubscribe();
    }
  }

  loadUserState() {
    this.loadingData = true;
    this.app.refreshUserState(this.subscriptionService);
  }

  interactiveView(interactive: US_Interactive): boolean {


    const queryStringParams = {
      interactId: interactive.interactId.toString(),
      interactType: "Interactive",
      actionType: "view",
      filterId: "-1",
      bookmarkId: "-1",
      reportId: "-1"
    };

    this.router.navigate([
      "powerbi-embedded",
      queryStringParams.interactId,
      queryStringParams.interactType,
      queryStringParams.actionType,
      queryStringParams.filterId,
      queryStringParams.bookmarkId,
      queryStringParams.reportId
    ]);

      return false;
  }

  modifiedInteractiveView(interactive: US_ModifiedInteractive): boolean {
    const queryStringParams = {
      interactId: interactive.modInteractId.toString(),
      interactType: "ModifiedInteractive",
      actionType: "view",
      filterId: "-1",
      bookmarkId: "-1",
      reportId: "-1",
      preFilterId: "-1",
    };

    this.router.navigate([
      "powerbi-embedded",
      queryStringParams.interactId,
      queryStringParams.interactType,
      queryStringParams.actionType,
      queryStringParams.filterId,
      queryStringParams.bookmarkId,
      queryStringParams.reportId
    ]);

    return false;
  }

  interactiveCopyAndEdit(interactive: US_Interactive): boolean {
    const dialogData: CopyInteractiveDialogData = {
      dialogTitle: "Copy & Edit Interactive",
      name: "",
      shareState: UserStateEx.getModifiedInteractiveShareState(this.userState,  {
        allowEdit: true,
        shares: [],
        modInteractId: 0,
        subscriptionHeaders: [],
        interactive: undefined,
        bookmarks: [],
        interactId: 0,
        name: '',
        owner: true,
        createdBy: undefined,
        modifiedTimeStamp: undefined,
        powerBidatasetId: undefined,
        userId: 0,
        subscriptionId: 0,
        deleted: false
      }),
      userSubscriptions: interactive.subscriptionHeaders,
      isOwner: true
    };

    const dialogRef = this.dialog.open(CopyInteractiveDialogComponent, {
      width: "500px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (
        dialogResult != null &&
        dialogResult.ResultType != null &&
        dialogResult.ResultType == DialogResultType.Ok
      ) {
        const params: InteractivesService.InteractivesDuplicateInteractiveParams = {
          interactiveId: interactive.interactId,
          newName: dialogResult.ResultData.name,
        };

        this.app.pushLoading("Creating Modified Interactive...");

        this.interactiveService
          .interactivesDuplicateInteractive(params)
          .subscribe(
            (result) => {

              this.interactiveService
                .interactivesUpdateInteractiveSharing({
                  interactiveId: result.properties.ModifiedInteractiveId,
                  updateSharingStatus: UserStateEx.getSharingStatus(
                    dialogResult.ResultData.shareState
                  ),
                })
                .subscribe(nextResult => {
                  const queryStringParams = {
                    interactId: result.properties.ModifiedInteractiveId.toString(),
                    interactType: "ModifiedInteractive",
                    actionType: "edit",
                    filterId: "-1",
                    bookmarkId: "-1",
                    reportId: "-1",
                  };

                  this.subscriptionService
                    .subscriptionGetUserSubscriptionState()
                    .subscribe((userState) => {
                      this.app.setUserState(userState);

                      this.app.popLoading();

                      this.router.navigate([
                        "powerbi-embedded",
                        queryStringParams.interactId,
                        queryStringParams.interactType,
                        queryStringParams.actionType,
                        queryStringParams.filterId,
                        queryStringParams.bookmarkId,
                        queryStringParams.reportId,
                      ]);
                    });
                })
              return false;
            },
            (error) => {
              var e = 0;
            }
          );
      }
    });

    return false;
  }

  modifiedInteractiveEdit(interactive: US_ModifiedInteractive) {
    const queryStringParams = {
      interactId: interactive.modInteractId.toString(),
      interactType: "ModifiedInteractive",
      actionType: "edit",
      filterId: "-1",
      bookmarkId: "1",
      reportId: "-1",
      preFilterId: "-1",
    };

    this.router.navigate([
      "powerbi-embedded",
      queryStringParams.interactId,
      queryStringParams.interactType,
      queryStringParams.actionType,
      queryStringParams.filterId,
      queryStringParams.bookmarkId,
      queryStringParams.reportId
    ]);

    return false;
  }

  modifiedInteractiveDelete(interactive: US_ModifiedInteractive): boolean {
    const dialogData: ConfirmDialogData = {
      title: "Confirm Delete",
      prompt:
        "Are you sure you want to delete interactive '" +
        interactive.name +
        "'?",
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "500px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result !== null &&
        result.ResultType !== null &&
        result.ResultType === DialogResultType.Ok
      ) {
        this.interactiveService
          .interactivesDeleteInteractive(interactive.modInteractId)
          .subscribe(
            (result) => {
              this.loadUserState();

              return false;
            },
            (error) => {}
          );
      }
    });

    return false;
  }

  /*
  preFilterInteractiveView(interactive: US_PreFilterInteractives) {
    const queryStringParams = {
      interactId: interactive.preFilteredInteractiveId.toString(),
      interactType: "PreFilteredInteractive",
      actionType: "view",
      filterId: "-1",
      bookmarkId: "-1",
      reportId: "-1",
    };

    this.router.navigate([
      "powerbi-embedded",
      queryStringParams.interactId,
      queryStringParams.interactType,
      queryStringParams.actionType,
      queryStringParams.filterId,
      queryStringParams.bookmarkId,
      queryStringParams.reportId,
    ]);
    return false;
  }

  preFilteredInteractiveCreate(interactive: US_Interactive): boolean {
    this.router.navigate(["edit-interactive-prefilter", interactive.interactId, 0]);
    return false;
  }

  preFilterInteractiveEdit(interactive: US_PreFilterInteractives) {
    this.router.navigate(["edit-interactive-prefilter", interactive.interactId, interactive.preFilteredInteractiveId]);
    return false;
  }

  preFilterInteractiveDelete(interactive: US_PreFilterInteractives) {
    const dialogData: ConfirmDialogData = {
      title: "Confirm Delete",
      prompt:
        "Are you sure you want to delete interactive '" +
        interactive.name +
        "'?",
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "500px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result !== null &&
        result.ResultType !== null &&
        result.ResultType === DialogResultType.Ok
      ) {
        this.preFilterInteractiveService
          .preFilterInteractivesDeletePreFilterInteractive(interactive.preFilteredInteractiveId)
          .subscribe(
            (result) => {
              this.loadUserState();

              return false;
            },
            (error) => {}
          );
      }
    });
    return false;
  }
  */
}
